(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moonessa-guide-intro"] && !Shopify.designMode) return;
  try {
    

(() => {
 const root = () => document.querySelector('[data-mn-guide]');
 function revealHash(scroll) {
  if (!root() || !location.hash) return;
  let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
  const target = document.getElementById(id); if (!target) return;
  let parent = target.closest('details');
  while (parent) { parent.open = true; parent = parent.parentElement.closest('details'); }
  if (target.matches('details')) target.open = true;
  if (scroll) requestAnimationFrame(() => target.scrollIntoView({block:'start',behavior:'instant'}));
 }
 document.addEventListener('click', event => {
  const link = event.target.closest('a[href^="#"]'); if (!root() || !link) return;
  let id; try { id = decodeURIComponent(link.getAttribute('href').slice(1)); } catch (_) { return; }
  const target = document.getElementById(id); if (!target) return;
  let panel = target.closest('details'); while(panel) {panel.open=true;panel=panel.parentElement.closest('details');}
  if(target.matches('details')) target.open=true;
  if(location.hash === link.getAttribute('href')) revealHash(true);
 });
 window.addEventListener('hashchange', () => revealHash(true));
 window.addEventListener('pageshow', () => revealHash(true));
 document.addEventListener('DOMContentLoaded', () => revealHash(true));
 document.addEventListener('shopify:section:load', () => revealHash(false));
 document.addEventListener('shopify:block:select', event => { const panel=event.target.closest('.mn-panel');if(panel)panel.open=true; });
 let printed=[];
 window.addEventListener('beforeprint', () => {printed=[...document.querySelectorAll('.mn-panel:not([open])')];printed.forEach(panel=>panel.open=true);});
 window.addEventListener('afterprint', () => {printed.forEach(panel=>panel.open=false);printed=[];});
 revealHash(false);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonessa-reward-qr"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseRewardQr = () => {
      document.querySelectorAll('[data-reward-qr-root]').forEach((root) => {
        if (root.dataset.initialised === 'true') return;

        const params = new URLSearchParams(window.location.search);
        const code = (params.get('code') || '').trim().toUpperCase();
        const isValid = /^[A-Z0-9-]{4,64}$/.test(code);
        const content = root.querySelector('[data-reward-qr-content]');
        const error = root.querySelector('[data-reward-qr-error]');

        if (!isValid) {
          root.dataset.initialised = 'true';
          error.hidden = false;
          return;
        }

        if (typeof window.QRCode !== 'function') return;

        root.dataset.initialised = 'true';

        const discountUrl = `${root.dataset.discountBase}${encodeURIComponent(code)}`;
        const qrTarget = root.querySelector('[data-reward-qr-image]');
        const codeTarget = root.querySelector('[data-reward-code]');
        const copyButton = root.querySelector('[data-reward-copy]');
        const copyStatus = root.querySelector('[data-reward-copy-status]');

        codeTarget.textContent = code;
        new window.QRCode(qrTarget, {
          text: discountUrl,
          width: 280,
          height: 280,
          correctLevel: window.QRCode.CorrectLevel.M
        });
        content.hidden = false;

        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(code);
            copyStatus.textContent = root.dataset.copySuccess;
          } catch (copyError) {
            copyStatus.textContent = code;
          }
        });
      });
    };

    const startRewardQr = () => {
      initialiseRewardQr();
      if (typeof window.QRCode === 'function') return;

      const library = document.querySelector('[data-reward-qr-library]');
      if (library) library.addEventListener('load', initialiseRewardQr, { once: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startRewardQr);
    } else {
      startRewardQr();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
